'use client';

export const getMultiplan = (type?: 'U_M' | '_M') => {
  if (type) {
    return `MULTIPLAN_COVERRIGHT_2026${type}`
  }

  if (typeof document !== "undefined") {
    if (document.location.host === 'plan.coverrightmedicare.com') {
      return 'MULTIPLAN_COVERRIGHT_2026_M'
    }
  }

  return 'MULTIPLAN_COVERRIGHT_2026U_M'
}
